export const PROFILE_QUERY_KEYS = {
  all: ["profiles"] as const,
  ageGroups: () => ["age-groups"] as const,
  entityBranches: () => ["entity-branches"] as const,
  trophies: (userId: string, limit: number, offset: number) => ["trophies", userId, limit, offset] as const,
} as const;
